import { render } from "./MedicalRecordDialog.vue?vue&type=template&id=99aa039e&scoped=true"
import script from "./MedicalRecordDialog.vue?vue&type=script&lang=js"
export * from "./MedicalRecordDialog.vue?vue&type=script&lang=js"

import "./MedicalRecordDialog.vue?vue&type=style&index=0&id=99aa039e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99aa039e"]])

export default __exports__